// extracted by mini-css-extract-plugin
export default {"modal":"DO-z","modalOverlay":"EO-z","outfitHeading":"FO-z"};